<script setup lang="ts">
import { faArrowLeft } from '@fortawesome/pro-light-svg-icons'
import { cva } from 'class-variance-authority'

const backButtonVariants = cva('group flex items-center font-body', {
  variants: {
    variant: {
      plain: 'gap-2xs text-primary text-xsmall',
      outlined: 'gap-xs text-base text-neutral-black',
    },
  },
})

withDefaults(
  defineProps<{
    variant?: 'plain' | 'outlined'
  }>(),
  {
    variant: 'plain',
  },
)
</script>

<template>
  <button type="button" aria-label="Gå tilbake" :class="backButtonVariants({ variant })">
    <span
      v-if="variant === 'outlined'"
      class="inline-flex size-8 shrink-0 items-center justify-center rounded-lg border border-border-default text-primary group-hover:bg-blurple-100"
      aria-hidden="true"
    >
      <Icon :icon="faArrowLeft" size="sm" />
    </span>
    <Icon v-else :icon="faArrowLeft" size="sm" />
    <slot />
  </button>
</template>
